import React from "react";
import DynamicUniversityPage from "../../../custom-components/DynamicUniversityPage";
import { manavRachnaUniversityJson } from "./ManavRachnaUniversityJson";
import DynamicWhyChooseThisUniversitiesPage from "../../../custom-components/DynamicWhyChooseThisUniversityPage";
import UniversityKnowMore from "src/CountryPages/University/UniversityKnowMore";
import Location from "../../../custom-components/Location";
import DynamicUniversityDetails from "../../../custom-components/DynamicUniversityDetails";
import DynamicNationalitySelection from "../../../custom-components/DynamicNationalitySelection";

const ManavRachnaUniversity = ({ data }) => {
  const { heading, backgroundImage, content } =
    manavRachnaUniversityJson.BannerData;

  return (
    <>
      <DynamicUniversityPage
        heading={heading}
        backgroundImage={backgroundImage}
        content={content}
      />
      <DynamicUniversityDetails
        data={manavRachnaUniversityJson.universityDetails}
      />
      <DynamicWhyChooseThisUniversitiesPage
        rankingsData={manavRachnaUniversityJson?.WhyChooseThisUniversityPage}
      />
      <DynamicNationalitySelection data={manavRachnaUniversityJson} />
      <Location
        header={manavRachnaUniversityJson?.Location.header}
        image={manavRachnaUniversityJson?.Location.image}
        content={
          manavRachnaUniversityJson?.Location?.content || "No content available"
        }
      />
      <UniversityKnowMore data={manavRachnaUniversityJson?.KnowMore} />
    </>
  );
};

export default ManavRachnaUniversity;
